<template>
  <b-form @submit.prevent="startMonitoringPopup">
    <b-card class="border0" body-class="p-0">
      <b-row>
        <b-col>
          <label>모니터링 제목</label>
          <b-form-input v-model="monitoringTitle" required></b-form-input>
        </b-col>
      </b-row>
    </b-card>
    <b-card
      class="border0"
      body-class="p-0 default-border1 bd-rd0"
      header-class="default-border1 bd-rd0"
      header-tag="header"
    >
      <h6 slot="header">구조물 선택</h6>
      <ag-grid-vue
        class="ag-theme-balham monitoringGrid"
        :gridOptions="monitoringGridOptions"
      ></ag-grid-vue>
    </b-card>
    <div class="btnGrp">
      <div class="jcse">
        <b-button class="full-searchBtn" type="submit"
          ><i class="fa fa-desktop"></i>시작</b-button
        >
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </b-form>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";

export default {
  components: {
    AgGridVue,
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAlertOptions", "getConfirmOptions"]),
  },
  data() {
    return {
      monitoringTitle: "모니터링",
      monitoringGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "multiple",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
    };
  },
  created() {},
  beforeMount() {
    this.monitoringGridOptions.columnDefs = [
      { headerName: "", field: "check", checkboxSelection: true, width: 50 },
      { headerName: "프로젝트", field: "projectnm", width: 160 },
      { headerName: "그룹", field: "groupnm", width: 120 },
      { headerName: "구조물", field: "structurenm", width: 120 },
      { headerName: "구조물ID", field: "structureid", hide: true },
    ];
  },
  mounted() {
    this.getStructureList();
  },
  destroyed() {},
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    getStructureList() {
      var reqBody = {};
      this.$http.post("/comn/getTree", reqBody).then((res) => {
        if (res.data.resultyn === "Y") {
          var treeData = res.data.treedata;
          var rowData = [];
          for (let i = 0; i < treeData.length; i++) {
            rowData.push({
              projectnm: treeData[i].pname,
              groupnm: treeData[i].gname,
              structurenm: treeData[i].sname,
              structureid: treeData[i].stid,
            });
          }
          this.monitoringGridOptions.api.setRowData(rowData);
        } else {
          console.error(res.data.errormsg);
        }
      });
    },
    startMonitoringPopup() {
      var sel = this.monitoringGridOptions.api.getSelectedRows();
      let selIdx = "";
      for (let i = 0; i < sel.length; i++) {
        selIdx += sel[i].structureid;
        if (i + 1 !== sel.length) selIdx += ",";
      }
      var url =
        window.location.origin +
        "/#/monitoring?stid=" +
        selIdx +
        "&title=" +
        this.monitoringTitle;
      let width = 1920;
      let height = 988;
      // console.log('Width : ' + width + ', Height : ' + height)
      this.closeModal();
      window.open(
        url,
        "_blank",
        "width=" + width + ",height=" + height + ",left=-8,top=0, resizable=yes"
      );
    },
    closeModal() {
      this.$bvModal.hide("selectMonitoringModal");
    },
  },
};
</script>

<style lang="scss">
#selectMonitoringModal .modal-dialog {
  max-width: 700px;
  & .modal-content {
    & .card {
      padding: 0px 30px 30px;
      &:first-child {
        padding-top: 30px;
      }
      & .card-header {
        padding: 8px 20px;
        & h6 {
          font-size: 15px;
        }
      }
      & .card-body {
        & > .row {
          height: 60px;
          padding: 0 20px;
          & > .col {
            padding: 15px 0;
            & label {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              font-size: 15px;
              width: 120px;
            }
            & input {
              width: calc(100% - 130px);
              border: 1px solid #666;
              border-radius: 5px;
            }
          }
        }
      }
    }
    & div.ag-theme-balham.monitoringGrid {
      height: 350px !important;
      & .ag-root .ag-body .ag-body-viewport {
        overflow-x: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SelectMonitoringModal.vue